import React from 'react';
import "./error.css"
import Navbar from '../components/farh/layout/nav';
const Error = () => {
    return ( <>
      <Navbar/>
    <section className='section11'>
        <div className='errordiv'>
            <div className='child1'>
                <h1 className='pardon'>
                    Pardon 
                    <span> the interruption .</span>
                </h1>
                <h6 className='reenterr'>re-enter your values and try again.</h6>
            </div>
            <div className='assetsimg'> </div>
        </div>
    </section>
    </> );
}
 
export default Error;